import { call, takeLatest } from 'redux-saga/effects';
import { heartbeatSuccess, heartbeatFailure, HEARTBEAT_REQUEST } from '../actions/heartbeat';
import { heartbeatService } from '../services/heartbeat';

const heartbeatWorker = function* () {
    try {
        yield call(heartbeatService);
        yield heartbeatSuccess();
    } catch (err) {
        yield heartbeatFailure(err);
    }
}

const heartbeatSagas = [
    takeLatest(HEARTBEAT_REQUEST, heartbeatWorker)
];

export default heartbeatSagas;
